import Dbm from "dbm";
import Website from "../../../index.js";

export default class FlyingEnemy extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);
        this.item.setValue("sprite", null);
        this.item.setValue("speed", 0);
        this.item.setValue("speedY", 0);

        let height = 13;
        let width = 37;

        this.item.setValue("x", 0);
        this.item.setValue("y", 0);

        

        const body = Matter.Bodies.rectangle(0, 0, width, height, {
            label: "enemy",
            isSensor: true,
            isStatic: true,
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.ENEMIES, Website.game.PhysicsGroups.ENEMIES_INTERACTIONS)
        });
        
        this.item.setValue("physicsBody", body);
    }

    setSprite(aSprite) {
        this.item.sprite = aSprite;
        this.item.pixiLayer.addChild(aSprite);

        return this;
    }

    setIntialPosition(aCameraPosition) {
        let currentPosition = this.item.physicsBody.position;

        let x = this.item.x - aCameraPosition + Website.game.Sizes.CENTER_X;

        Matter.Body.setPosition(this.item.physicsBody, {
            x: x,
            y: -1*this.item.y
        });
    }

    update(aCameraPosition, aTime, aDelta) {
        //console.log("FlyingEnemy::update");

        let currentPosition = this.item.physicsBody.position;

        if(this.item.speed) {
            this.item.x -= this.item.speed*aDelta;
        }
        if(this.item.speedY) {
            this.item.y += this.item.speedY*aDelta;
        }

        let x = this.item.x - aCameraPosition + Website.game.Sizes.CENTER_X;

        Matter.Body.setPosition(this.item.physicsBody, {
            x: x,
            y: -1*this.item.y
        });

        let height = 13;

        this.item.pixiLayer.x = this.item.physicsBody.position.x;
        this.item.pixiLayer.y = this.item.physicsBody.position.y+(0.5*height)+(Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION);

        //console.log(this.item.pixiLayer.x, this.item.pixiLayer.y);
    }
}